import { useEffect } from "react";

const LAST_CLUSTER_SLUG = "lastClusterId";

export const useSetLastSelectedClusterSlug = (
    clusterSlug: string | undefined
): void => {
    useEffect(() => {
        if (clusterSlug) {
            localStorage.setItem(LAST_CLUSTER_SLUG, clusterSlug);
        }
    }, [clusterSlug]);
};

export const clearLastSelectedClusterSlug = (): void => {
    localStorage.removeItem(LAST_CLUSTER_SLUG);
};

export const useLastSelectedClusterSlug = (): string | null => {
    return localStorage.getItem(LAST_CLUSTER_SLUG);
};
